export default __webpack_public_path__ + "static/media/most-popular-artwork-3.d41f9c4b.png";